import { render, staticRenderFns } from "./ym-sales-volume.vue?vue&type=template&id=42885ea8&"
import script from "./ym-sales-volume.vue?vue&type=script&lang=js&"
export * from "./ym-sales-volume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports